/**
 * @name Enum
 */

export enum HttpStatusCode {
  Ok = 200,
  MovedPermanently = 301,
  MovedTemporarily = 302,
  SeeOther = 303,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  InternalServerError = 500
}

/**
 * @name String Enum
 */

export const LIST_KEY_ERROR_FROM_BACKEND = {
  REGISTER: 'REGISTER'
}

export const DEFAULT_PAGE_SIZE = 25
export const DEFAULT_MAX_PAGE_SIZE = 2500
export const DEFAULT_MOUNT_PAGE_SIZE = 10
export const DEFAULT_LOADING_PAGE_SIZE = 5
export const DEFAULT_ASYNC_LOADING_OPTIONS = 15
export const MAX_CHARACTERS_INTRODUCTION = 10000
export const MAX_FILES_UPLOAD_AT_ONCE = 5

export const REMOTE_STATUS = {
  NO_REMOTE: 'no_remote',
  HYDRID_REMOTE: 'hybrid_remote',
  FULLY_REMOTE: 'fully_remote'
}

export const REFERRAL = 'referral'
export const REQUISITION = 'requisition'
export const IMPORT_JOB = 'import_job'
export const SSO = 'sso'

export const DIRECT_EMPLOYER_TENANT = 'employer'
export const AGENCY_TENANT = 'agency'
export const PRIVATE = 'private'
export const PUBLIC = 'public'

export const GLEAP_EVENTS = {
  firstLocationCreated: 'firstLocationCreated',
  firstDepartmentCreated: 'firstDepartmentCreated',
  firstJobCreated: 'firstJobCreated',
  firstCandidateAdded: 'firstCandidateAdded',
  firstMemberInvited: 'firstMemberInvited'
}
export const JOB = 'job'
export const PROFILE = 'profile'
export const CONTACT = 'contact'
export const COMPANY = 'company'
export const EMAIL = 'email'
export const PHONE = 'phone'
export const LOCATION = 'location'
export const LINKS = 'links'
export const CONTACT_DETAILS = [JOB, EMAIL, PHONE, LOCATION, LINKS]
export const LOCAL = 'local'
export const CLOUD = 'cloud'
export const RESUME = 'resume'
export const PROFILE_TABS = {
  INFORMATION: 'information',
  RESUME: 'resume',
  FILES: 'files',
  IN_ACTIVE: 'item-in-active'
}
export const STAGE_TYPE = {
  sourced: { id: 1, label: 'Sourced' },
  applied: { id: 2, label: 'Applied' },
  screening: { id: 3, label: 'Screening' },
  interview: { id: 4, label: 'Interview' },
  offer: { id: 5, label: 'Offer' },
  hired: { id: 6, label: 'Hired' },
  clientSubmission: { id: 7, label: 'Client submission' }
}
export const UPLOAD = 'upload'
export const PENDING = 'pending'
export const ERROR = 'error'
export const WARNING = 'warning'

export const MAXIMUM_SIZE_FILE_TEXT = '10MB'

export const PERMISSION_MODULE = {
  report: 'report'
}
export const TAB_MEMBERS = 'members'
export const TAB_TEAMS = 'teams'
export const TAB_CANDIDATES = 'candidates'
export const TAB_COMPANIES = 'companies'
export const KEY_FILTER_TEAM_AND_MEMBER = {
  profitSplitUserIds: 'profitSplitUserIds',
  departmentIds: 'departmentIds',
  ownerIds: 'ownerIds',
  hiringMemberIds: 'hiringMemberIds',
  membersOfDepartmentIds: 'membersOfDepartmentIds'
}
export const LIST_ACTION_FILTERS = {
  updateView: 'UPDATE_VIEW',
  applyFilter: 'APPLY_FILTER',
  clearFilter: 'CLEAR_FILTER',
  saveAsNewView: 'SAVE_AS_NEW_VIEW'
}
